module.exports = __webpack_public_path__ + "static/img/2024_activities.033ee86c.jpeg";